import * as React from 'react';

export function useListenForVirtualKeyboard(containerRef: React.RefObject<HTMLElement>): boolean {
  const [virtualKeyboardOpen, setVirtualKeyboardOpen] = React.useState(false);

  // the general heuristic for detecting virtual keyboard is to listen for focus events
  // on inputs and textareas. This is not perfect, but it's the best we can do.
  React.useEffect(() => {
    if (
      containerRef.current &&
      ('ontouchstart' in window || // works on most browsers
        navigator.maxTouchPoints)
    ) {
      const container = containerRef.current;

      const handleFocus = (event: Event): void => {
        if (
          event.target instanceof HTMLElement &&
          (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA')
        ) {
          setVirtualKeyboardOpen(true);
        }
      };
      const handleBlur = (event: Event): void => {
        if (
          event.target instanceof HTMLElement &&
          (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA')
        ) {
          setVirtualKeyboardOpen(false);
        }
      };
      container.addEventListener('focusin', handleFocus);
      container.addEventListener('focusout', handleBlur);
      return () => {
        container.removeEventListener('focusin', handleFocus);
        container.removeEventListener('focusout', handleBlur);
      };
    }
    // oxlint-disable-next-line react/exhaustive-deps
  }, []);

  return virtualKeyboardOpen;
}
